import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Input, Space, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import Header from "../../Header/Header";
import SideBar from "../../SideBar/SideBar";
import Footer from "../../Footer/Footer";

import "./adminstudent.css";
import {
  getAllStudentsView,
  getAllStudentsViewWithSorting,
  getReportsCount,
  searchUsers,
} from "../../HttpRequest/userdetails";
import Pagination from "../Base UI/Pagination";
import Table2 from "./Table2";

const StudentCopy = () => {
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [pagedata, setPageData] = useState();
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });
  const [sortOrder, setSortOrder] = useState();

  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };

  

  useEffect(() => {
     fetchData();
  }, [pageInfo, sortOrder]);

  const handleNameSort = async(order) => {
    console.log("order ==>", order);
    if (order == "asc") {
      setSortOrder({ fieldName: "firstName", direction: "asc" }); 
    }else{
      console.log("desc");
      setSortOrder({ fieldName: "firstName", direction: "desc" });
    }
  };
  const handleEmailSort = async(order) => {
    if (order == "asc") {
      setSortOrder({ fieldName: "email", direction: "asc" }); 
    }else{
      console.log("desc");
      setSortOrder({ fieldName: "email", direction: "desc" });
    }
  };

  const fetchData = async () => {
    try {
      let result;
      console.log("oder in side the fetch before ==>", sortOrder);
      if (sortOrder && ["firstName", "email"].includes(sortOrder.fieldName) && ["asc", "desc"].includes(sortOrder.direction)) {
        console.log("oder in side the fetch ==>", sortOrder);
        result = await getAllStudentsViewWithSorting(
          "user",
          pageInfo.page, pageInfo.size,sortOrder
        );         
      } else {
        result = await getAllStudentsView("user", pageInfo.page, pageInfo.size);
        console.log("else");
      }
      console.log("get all students result ==>", result);
      const response = result.data.data;
      console.log("get all students ==> ", response);
      const formattedData = await response.map((item) => ({
        key: item.id,
        createdDate: item.createdDate,
        fullName: `${item.firstName} ${item.lastName}`,
        email: item.email,
        phoneNumber: item.phoneNumber,
        totalWishlistCount: item.totalWishlistCount,
        totalAppliedUniversityCount: item.totalAppliedUniversityCount,
      }));
      console.log("Formated Data===>",formattedData);
      setData(formattedData);
      setPageData(result.data.metaData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phoneNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const applicationFilter = () => {
    console.log("Filter criteria:", formData);
    searchUsers("user", formData, pageInfo.page, pageInfo.size)
      .then((response) => {
        const result = response.data.data;
        console.log("response of the  search users==>", result);
        const formattedData = result.map((item) => ({
          key: item.id,
          createdDate: item.createdDate,
          fullName: `${item.firstName} ${item.lastName}`,
          email: item.email,
          phoneNumber: item.phoneNumber,
          totalWishlistCount: item.totalWishlistCount,
          totalAppliedUniversityCount: item.totalAppliedUniversityCount,
        }));
        setData(formattedData);
        setPageData(response.data.metaData);
      })
      .catch((error) => {
        console.error("Error filtering data:", error);
      });
  };

  const columns = [
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "10%",
      render: (text) => (searchText ? <b>{text}</b> : text),
    },
    {
      title: (
        <>
          <span>Name</span>
          <Button onClick={() => handleNameSort("asc")}>↑</Button>
          <Button onClick={() => handleNameSort("desc")}>↓</Button>
        </>
      ),
      dataIndex: "fullName",
      key: "firstName",
      width: "10%",
    },
    {
      title: (
        <>
          <span>Email</span>
          <Button onClick={() => handleEmailSort("asc")}>↑</Button>
          <Button onClick={() => handleEmailSort("desc")}>↓</Button>
        </>
      ),
      dataIndex: "email",
      key: "email",
      width: "15%",
      render: (text) => (searchText ? <b>{text}</b> : text),
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: "10%",
      render: (text) => (searchText ? <b>{text}</b> : text),
    },
    {
      title: "Total Shortlisted ",
      dataIndex: "totalWishlistCount",
      key: "key",
      width: "18%",
      render: (text, record) => (
        <Link
          to={{
            pathname: "/wishlistchatcard",
            state: { passingUserId: record.key },
          }}
        >
          <div>{searchText ? <b>{text}</b> : text}</div>
        </Link>
      ),
    },
    {
      title: "Total Applications",
      dataIndex: "totalAppliedUniversityCount",
      key: "totalAppliedUniversityCount",
      width: "18%",
      render: (text, record) => (
        <Link
          to={{
            pathname: "/universitychatcard",
            state: { passingUserId: record.key },
          }}
        >
          <div>{searchText ? <b>{text}</b> : text}</div>
        </Link>
      ),
    },
  ];

  const mystyle = {
    width: "90%",
    height: "2.2rem",
    borderRadius: "0.6rem",
    border: "none",
    backgroundColor: "transparent",
    outline: "none",
    display: "flex",
    alignItems: "center",
  };
  const searchbarStyle = {
    display: "flex",
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <SideBar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">All Students </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Students</li>
                  </ul>
                </div>
              </div>
            </div>

             <div  className="card p-1">
            <Table2   />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default StudentCopy;
